import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTable from 'react-table';

import TextField from 'material-ui/TextField';

import * as landlordInspections from 'actions/landlordInspectionsActions';

import { startsWith, isFilterInStrings } from 'helpers/StringHelper.js';
import { InspectionsDropdown, renderStatus } from 'helpers/Inspections';
import { toFriendlyDateString } from 'helpers/Formatter';
import { numberOfRows } from 'helpers/ReactTableSize';
import { getFilterText } from 'helpers/Filter';

export default connect(
  store => {
    return {
      inspections: store.landlordInspections.inspections,
    };
  },
  dispatch => {
    return {
      getInspections: () => {
        dispatch(landlordInspections.getInspections());
      },
    };
  }
)(
  class InspectionList extends Component {
    constructor(props) {
      super(props);

      const tableSize = numberOfRows(props.inspections, 'property');
      this.state = {
        tableSize,
        data: props.inspections,
        error: '',
        filterText: '',
      };
    }

    UNSAFE_componentWillMount() {
      this.props.getInspections();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      const tableSize = numberOfRows(nextProps.inspections, 'property');
      this.setState(
        {
          tableSize,
          data: nextProps.inspections,
        },
        () => this.forceUpdate()
      );
    }

    render() {
      const filteredData = this.state.data.filter(item =>
        isFilterInStrings([item.unit, item.inspection_type], this.state.filterText)
      );

      const columns = [
        {
          header: 'Property',
          headerClassName: 'headerColumn',
          accessor: 'property',
          width: 80,
          getProps: (state, rowInfo, column) => {
            return {
              style: {
                overflow: 'initial',
              },
            };
          },
        },
        {
          header: 'Unit',
          headerClassName: 'headerColumn',
          accessor: 'unit',
          width: 80,
        },
        {
          header: 'Inspection Type',
          headerClassName: 'headerColumn',
          accessor: 'inspection_type',
        },
        {
          header: 'Date Created',
          headerClassName: 'headerColumn',
          accessor: 'date_created',
          render: row => (row.rowValues.date_created ? toFriendlyDateString(row.value) : ''),
        },
        {
          header: 'Status',
          headerClassName: 'headerColumn',
          accessor: 'status',
          render: row => (row.rowValues.status ? renderStatus(row.value) : ''),
        },
        {
          header: '',
          headerClassName: 'actions',
          render: row =>
            row.rowValues.inspection_type && row.rowValues.status !== 'Pending' ? (
              <InspectionsDropdown
                data={row.row}
                openDocumentPortal={this.props.openDocumentPortal}
              />
            ) : (
              ''
            ),
        },
      ];

      return (
        <div>
          <div className="stage-header clearfix">
            <span className="page-title">Property Inspection</span>
          </div>

          <div className="row" style={{ marginTop: '-20px' }}>
            <TextField
              hintText="Filter by Inspection"
              style={{ fontSize: '13px' }}
              value={this.state.filterText}
              onChange={e => getFilterText(e, this)}
            />
          </div>

          <ReactTable
            collapseOnSortingChange={false}
            collapseOnPageChange={false}
            collapseOnDataChange={false}
            data={filteredData}
            columns={columns}
            showFilters={false}
            showPagination={false}
            showPageSizeOptions={false}
            pageSize={this.state.tableSize}
            noDataText="No Inspections"
            defaultFilterMethod={(filter, row, column) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? startsWith(String(row[id]).toLowerCase(), filter.value)
                : true;
            }}
            freezeWhenExpanded={this.props.shouldFreeze}
            pivotBy={['property']}
          />

          <div style={{ height: '100px' }} />
        </div>
      );
    }
  }
);
